/**
 * External Imports
 */
import styled, { css } from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuFeedback } from '@neutron/react';

interface IStyledCompleteBtnProps {
  bg?: string;
}

export const StyledCompleteBtn = styled(NeuButton)<IStyledCompleteBtnProps>`
  ${props =>
    props.bg === 'green'
      ? css`
          background-color: rgb(70, 125, 32) !important;
          border-color: rgb(70, 125, 32);
          :hover {
            background-color: rgb(34, 64, 13) !important;
          }
        `
      : ''}
  & .button-text {
    min-width: 10em;
  }
`;

export const CustomNeuSpinner = styled(NeuFeedback)`
  margin: 0 3rem;
  > svg {
    height: 20px !important;
    width: 20px !important;
  }
`;
